module.exports = __webpack_public_path__ + "au.svg?ff78f4f533b33ed3a02506596e9856b2";